module.exports = __webpack_public_path__ + "img/bingo_ball-57.d4bd3488.png";